import { render, staticRenderFns } from "./SalaDeAula.vue?vue&type=template&id=56d402d5&scoped=true&"
import script from "./SalaDeAula.vue?vue&type=script&lang=js&"
export * from "./SalaDeAula.vue?vue&type=script&lang=js&"
import style0 from "./SalaDeAula.vue?vue&type=style&index=0&id=56d402d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d402d5",
  null
  
)

export default component.exports